import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { PersonOutline } from "@mui/icons-material";

interface WaitingMessageProps {
  isDoctor: boolean;
  hasRemoteUser: boolean;
}

export const WaitingMessage: React.FC<WaitingMessageProps> = ({
  isDoctor,
  hasRemoteUser,
}) => {
  if (hasRemoteUser) return null;

  const message = isDoctor
    ? "Aguardando paciente..."
    : "Aguardando médico(a)...";

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        zIndex: 50,
      }}
    >
      <Box
        sx={{
          width: 120,
          height: 120,
          borderRadius: "50%",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
        }}
      >
        <PersonOutline sx={{ fontSize: 60, color: "#fff" }} />
      </Box>
      <Typography
        variant="h5"
        sx={{
          color: "#fff",
          fontWeight: 500,
          mb: 2,
        }}
      >
        {message}
      </Typography>
      <CircularProgress
        size={32}
        sx={{
          color: "#0A6172",
        }}
      />
    </Box>
  );
};

export default WaitingMessage;
